export const WHAT_IF_ELIGIBLE_WORKFLOW_TYPES = [
  'person',
  'business',
];
